import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateWaitingAreaOperatingHours, getWaitingArea } from '../../../../actions/waitingArea';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowUpdateWaitingAreaOperatingHoursModal } from '../../../../actions/modal';
import { clone } from '../../../../reducers/helper.js';
import { verifyIfDaySelectionCorrect } from '../../../../businessLogic/operatingDaysAndHours';

export default function RightPanelUpdate(props) {
  const dispatch = useDispatch();
  const [isWaitingAreaUpdating, setIsWaitingAreaUpdating] = useState(false);

  const OperatingHoursUpdate = (e) => {
    if (!verifyIfDaySelectionCorrect(props.waitingAreaOperatingHoursForm.serviceOfferingAvailabilities)) {
      return;
    }
    let cb = (result, f) => {
      setIsWaitingAreaUpdating(false);
      if (result) resetForm();
    };
    setIsWaitingAreaUpdating(true);
    dispatch(
      updateWaitingAreaOperatingHours(
        props.waitingArea.id,
        removeEmptyOperationalHours(props.waitingAreaOperatingHoursForm),
        cb
      )
    );
  };

  const removeEmptyOperationalHours = (waitingAreaOperatingHoursForm) => {
    let operatingHours = clone(waitingAreaOperatingHoursForm);
    let correctOperatingHours = operatingHours.serviceOfferingAvailabilities.filter((x) => {
      return (
        x.isMondaySelected ||
        x.isTuesdaySelected ||
        x.isWednesdaySelected ||
        x.isThursdaySelected ||
        x.isFridaySelected ||
        x.isSaturdaySelected ||
        x.isSundaySelected
      );
    });
    operatingHours.serviceOfferingAvailabilities = correctOperatingHours;
    return operatingHours;
  };

  const cancelUpdateOperatingHours = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) dispatch(hideGlobalMessage());
    resetForm();
  };

  const resetForm = () => {
    dispatch(updateShowUpdateWaitingAreaOperatingHoursModal(false));
  };

  let saveClasses =
    'ui labeled icon button icon color-button color-button-hover color-white max-width left-text mrlnull mrbnull';
  if (!verifyIfDaySelectionCorrect(props.waitingAreaOperatingHoursForm.serviceOfferingAvailabilities)) {
    saveClasses += ' disable ';
  }
  return (
    <div>
      <div className="ui actions mrbl max-width">
        <button
          tabIndex="4"
          type="button"
          onClick={OperatingHoursUpdate}
          className={isWaitingAreaUpdating ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark  icon" />
        </button>
        <button
          tabIndex="5"
          type="button"
          onClick={cancelUpdateOperatingHours}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    </div>
  );
}
